exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".on-one-row[data-v-1f1f4b41] {\n  display: inline;\n}\n", ""]);

// exports
